import React from 'react';

const BMIGauge = ({ bmi }) => {
  // BMI ranges
  const ranges = [
    { min: 0, max: 18.5, label: 'Underweight', color: '#FCD34D' },
    { min: 18.5, max: 24.9, label: 'Healthy', color: '#34D399' },
    { min: 25, max: 29.9, label: 'Overweight', color: '#FCD34D' },
    { min: 30, max: 50, label: 'Obese', color: '#F87171' }
  ];

  // Calculate pointer angle based on BMI value
  const getPointerAngle = (bmiValue) => {
    const minBMI = 10;
    const maxBMI = 50;
    const minAngle = -90;
    const maxAngle = 90;
    
    // Clamp BMI value between min and max
    const clampedBMI = Math.min(Math.max(bmiValue, minBMI), maxBMI);
    
    // Convert BMI to angle
    return minAngle + ((clampedBMI - minBMI) / (maxBMI - minBMI)) * (maxAngle - minAngle);
  };

  // Get BMI category and color
  const getBMICategory = (bmiValue) => {
    const range = ranges.find(r => bmiValue >= r.min && bmiValue < r.max);
    return range || ranges[ranges.length - 1];
  };

  const pointerAngle = getPointerAngle(bmi);
  const category = getBMICategory(bmi);

  return (
    <div className="bg-white rounded-lg shadow-lg p-6">
      <div className="flex flex-col items-center">
        <div className="text-lg font-semibold mb-4">Your BMI: {bmi}</div>
        <svg viewBox="0 0 200 120" className="w-full max-w-sm">
          {/* Gauge Background */}
          <path
            d="M20 100 A 80 80 0 0 1 180 100"
            fill="none"
            stroke="#E5E7EB"
            strokeWidth="16"
            strokeLinecap="round"
          />
          
          {/* Color Segments */}
          <path
            d="M20 100 A 80 80 0 0 1 60 40"
            fill="none"
            stroke="#FCD34D"
            strokeWidth="16"
            strokeLinecap="round"
          />
          <path
            d="M60 40 A 80 80 0 0 1 100 32"
            fill="none"
            stroke="#34D399"
            strokeWidth="16"
            strokeLinecap="round"
          />
          <path
            d="M100 32 A 80 80 0 0 1 140 40"
            fill="none"
            stroke="#FCD34D"
            strokeWidth="16"
            strokeLinecap="round"
          />
          <path
            d="M140 40 A 80 80 0 0 1 180 100"
            fill="none"
            stroke="#F87171"
            strokeWidth="16"
            strokeLinecap="round"
          />

          {/* Pointer */}
          <g transform={`rotate(${pointerAngle}, 100, 100)`}>
            <line
              x1="100"
              y1="100"
              x2="100"
              y2="30"
              stroke="black"
              strokeWidth="2"
              className="origin-bottom"
            />
            <circle cx="100" cy="100" r="5" fill="black" />
          </g>

          {/* Labels */}
          <text x="20" y="115" className="text-xs">10</text>
          <text x="180" y="115" className="text-xs">50</text>
        </svg>

        <div className="mt-4 text-center">
          <span
            className="px-3 py-1 rounded-full text-white text-sm font-medium"
            style={{ backgroundColor: category.color }}
          >
            {category.label}
          </span>
        </div>
      </div>
    </div>
  );
};

export default BMIGauge;